import { modal } from "./modal-instance";
import { openTheModal } from "./functions";

const target = document.getElementById('interviews');
const discountModalSelector = '[data-target="discount"]';
const requestModalSelector = '[data-target="request"]';


const observer = new IntersectionObserver(
    ([entry]) => {
        if (entry.isIntersecting && target) {
            observer.unobserve(target)

            if (modal.wasOpened(discountModalSelector)) {
                return
            }

            setTimeout(() => {
                if (modal.wasOpened(requestModalSelector)) {
                    return
                }
                openTheModal(discountModalSelector)
            }, 3000);

        }
    },
    { threshold: 0.5 }
);

observer.observe(target);
